var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(
      _vm.mode === 'editing' &&
      _vm.children.length === 0 &&
      _vm.$hasPermission('builder.page.create_element', _vm.currentPage, _vm.workspace.id)
    )?[_c('AddElementZone',{on:{"add-element":_vm.showAddElementModal}}),_vm._v(" "),_c('AddElementModal',{ref:"addElementModal",attrs:{"page":_vm.elementPage}})]:[_vm._l((_vm.children),function(child){return [(_vm.mode === 'editing')?_c('ElementPreview',{key:child.id,attrs:{"element":child},on:{"move":function($event){return _vm.$emit('move', $event)}}}):_c('PageElement',{key:`${child.id}else`,attrs:{"element":child,"mode":_vm.mode}})]})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }